import {
    ArrayField,
    ArrayFieldProps,
    ArrayInput,
    ArrayInputProps,
    AutocompleteInput,
    Datagrid,
    NumberField,
    NumberInput,
    ReferenceArrayField,
    ReferenceArrayFieldProps,
    ReferenceField,
    ReferenceInput,
    required,
    SimpleFormIterator,
    TextField,
    TextFieldProps,
    useRecordContext,
  } from 'react-admin';
import { locale, numberFormatConfiguration } from '../../components/numberFormatConfiguration';
import { PriceField } from '../../components/PriceField';
import { QuickbooksCalculatedPriceField } from '../../components/QuickbooksCalculatedPriceField';
  import { LinesDescriptionInput } from './LinesDescriptionInput';
  import { LinesPriceInput } from './LinesPriceInput';
  import { LineTaxInput } from './LinesTaxInput';
  import { LinesTypeField } from './LinesTypeField';

  
  export const LegacyLinesShow = (props: Omit<ArrayFieldProps, 'children'>) => {
    return (
      <ArrayField
        label="resources.contracts.lines.name"
        
            // sx={{
            //   '& .RaSimpleFormIterator-form': {
            //     flexDirection: 'row !important',
            //     gap: '15px',
            //     alignItems: 'center !important',
            //   },
            // }}
        {...props}
      >
          <Datagrid bulkActionButtons={false} sx={{marginBottom: '50px'}}>
            <TextField source="Type" />
            <TextField source="Description" />
            <PriceField source="Amount" />
            {/* <ReferenceField source="item" reference="items">
                <TextField source="FullyQualifiedName" />
            </ReferenceField>
            <NumberField source="price" />
            <NumberField source="quantity" />
            <ShowTotalPriceField label="Total"/> */}
          </Datagrid>
      </ArrayField>
    );
  };
  